import React from "react";
import ContactForm from "./ContactForm";

interface ContactProps {}

const Contact: React.FC<ContactProps> = (props) => {
  return (
    <section id="contact" className="px-6 lg:px-20 py-5 bg-white">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* LEFT - Info */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Liên hệ</h2>

          {/* Thông tin liên hệ */}
          <div className="space-y-5">
            {/* Item 1 */}
            <div className="flex items-center gap-4 bg-primary_gray p-4 rounded-xl shadow-sm">
              <div className="bg-primary_blue text-white p-2 rounded-full">
                {/* <FiPhoneCall size={20} /> */}
              </div>
              <div>
                <p className="font-semibold text-gray-800">Điện thoại</p>
                <p className="text-gray-600 text-sm">09.65.15.28.18</p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="flex items-center gap-4 bg-primary_gray p-4 rounded-xl shadow-sm">
              <div className="bg-primary_blue text-white p-2 rounded-full">
                {/* <TfiEmail size={20} /> */}
              </div>
              <div>
                <p className="font-semibold text-gray-800">Email</p>
                <p className="text-gray-600 text-sm">
                  sieuthidienlanh.vn@gmail.com
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="flex items-center gap-4 bg-primary_gray p-4 rounded-xl shadow-sm">
              <div className="bg-primary_blue text-white p-2 rounded-full">
                {/* <FiMapPin size={20} /> */}
              </div>
              <div>
                <p className="font-semibold text-gray-800">Địa chỉ</p>
                <p className="text-gray-600 text-sm">
                  14 D3 KDC Champaca Garden, Đông Hoà, Hồ Chí Minh
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT - Form */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Liên lạc</h2>
          <p className="text-gray-600 text-sm mb-8 max-w-md">
            Chúng tôi ưu tiên trả lời các câu hỏi của bạn một cách nhanh chóng
            để đảm bảo bạn nhận được sự hỗ trợ cần thiết một cách kịp thời.
          </p>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
